import React, { useCallback, useEffect, useRef, useState } from "react";

const MIN_WIDTH = 180;
const MAX_WIDTH = 480;
const DEFAULT_WIDTH = 220;

export function Panes({ children }) {
  return <div className="panes">{children}</div>;
}

export function Menu({ children }) {
  const [width, setWidth] = useState(DEFAULT_WIDTH);
  const containerRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    isResizing.current = true;
    document.body.style.cursor = "col-resize";
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "ArrowLeft") {
      setWidth((w) => Math.max(MIN_WIDTH, w - 10));
    } else if (e.key === "ArrowRight") {
      setWidth((w) => Math.min(MAX_WIDTH, w + 10));
    }
  }, []);

  useEffect(() => {
    function handleMouseMove(e) {
      if (!isResizing.current || !containerRef.current) return;
      const { left } = containerRef.current.getBoundingClientRect();
      const newWidth = Math.min(
        MAX_WIDTH,
        Math.max(MIN_WIDTH, e.clientX - left)
      );
      setWidth(newWidth);
    }
    function handleMouseUp() {
      if (!isResizing.current) return;
      isResizing.current = false;
      document.body.style.cursor = "";
    }
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <div className="pane__left" style={{ width }} ref={containerRef}>
      {children}
      <button
        type="button"
        className="pane__left__resizer"
        aria-label="Resize sidebar"
        onMouseDown={handleMouseDown}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}

export function Pane({ children }) {
  return <div className="pane">{children}</div>;
}
